import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setgetQuestionsError, setLoading, setGeneralQuestionList } from "../../repository/slice";

function* getIdeaListWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/admin/idea", payload);
        if (isError) {
            yield put(setgetQuestionsError(message));
        } else {
            yield put(setgetQuestionsError(null));
            yield put(setGeneralQuestionList({list: data.rows, count: data.count}));
        }
    } catch (error) {
        console.error("getIdeaListWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getIdeaListWatcher() {
    yield takeLatest("@saga/GET_IDEA_LIST", getIdeaListWorker);
};
